import React from 'react';
import { Header3 } from 'components/typography';
import Icon from 'components/icon/icon';
import A11yVisuallyHidden from 'components/a11y/a11y-visually-hidden';
import lexemes from 'components/lexemes';

export type ToggleCardHeaderProps = {
    children?: React.ReactNode | React.ReactNode[];
    onClick?: () => void;
    isActive?: boolean;
    hasCloseActionIcon?: boolean;
    contentId: string;
    tag?: 'h2' | 'h3' | 'div';
};

const ToggleCardHeader: React.FC<ToggleCardHeaderProps> = (props) => {
    const { children, onClick, isActive, hasCloseActionIcon, contentId, tag = 'div' } = props;
    const onClickHandler = () => {
        if (onClick) {
            onClick();
        }
    };

    const Tag = tag;

    return (
        <div className="toggle-card-header">
            <Tag className="toggle-card-header__heading">
                <button
                    className="toggle-card-header__toggle"
                    onClick={onClickHandler}
                    aria-expanded={Boolean(isActive)}
                    type="button"
                    aria-controls={isActive ? contentId : undefined}
                >
                    <span className="toggle-card-header__icon">
                        <Icon
                            name={isActive ? Icon.Name.ArrowDown : Icon.Name.ArrowRight}
                            size="stretch"
                        />
                    </span>
                    <span className="toggle-card-header__title">
                        <Header3>{children}</Header3>
                    </span>
                </button>
            </Tag>

            {isActive && hasCloseActionIcon ? (
                <button
                    className="toggle-card-header__close"
                    onClick={onClickHandler}
                    aria-controls={contentId}
                    type="button"
                >
                    <A11yVisuallyHidden>
                        {lexemes.tools.lxCloseSectionA11yLabel()}

                        {children}
                    </A11yVisuallyHidden>
                    <Icon name={Icon.Name.Close} size="stretch" />
                </button>
            ) : null}
        </div>
    );
};

export default ToggleCardHeader;
